document.addEventListener("DOMContentLoaded", function () {
  fetchReviews();
});

function fetchReviews() {
  fetch("https://script.google.com/macros/s/AKfycbzJJ6utwNNUGXxk7E1WZn2E-LnvNbywJF8mwZRVV_n2E1l4dx2iFeQHN6cNEH8QWzbW_Q/exec")
    .then(response => response.json())
    .then(data => {
      console.log("Fetched Data:", data); // Debug log
      if (Array.isArray(data) && data.length > 0) {
        // Use the data in its natural order (newest at top, if your sheet is sorted that way)
        displayReviews(data);
      } else {
        document.getElementById("reviews-container").innerHTML = "<p>No reviews available.</p>";
      }
    })
    .catch(error => {
      console.error("Error fetching reviews:", error);
      document.getElementById("reviews-container").innerHTML = "<p>Error loading reviews.</p>";
    });
}

function displayReviews(reviews) {
  const leftColumn = document.getElementById("left-column");
  const rightColumn = document.getElementById("right-column");

  if (!leftColumn || !rightColumn) {
    console.error("Error: Left or right column container not found");
    return;
  }
  
  // Clear previous content
  leftColumn.innerHTML = "";
  rightColumn.innerHTML = "";

  // Loop through reviews and alternate appending to left and right columns
  reviews.forEach((review, index) => {
    const reviewCard = document.createElement("div");
    reviewCard.classList.add("review-card");

    let imageHTML = "";
    let imageLink = review["IMAGELINKTIMESTAMP"];

    // Process only if it's a valid URL
    if (imageLink && imageLink.startsWith("http")) {
      let thumbnailLink = convertGoogleDriveLink(imageLink);
      imageHTML = `<img src="${thumbnailLink}" alt="${review["IMAGENAME"] || 'Review Image'}" class="review-image" onerror="this.style.display='none';">`;
    }

    // Generate star rating dynamically
    let starsHTML = "⭐".repeat(parseInt(review.RATING) || 0);

    reviewCard.innerHTML = `
      ${imageHTML}
      <p class="review-name">${review.NAME || "Anonymous"}</p>
      <p class="country">${review.COUNTRY || "Unknown"}</p>
      <p class="review-date">${review.DATE || "N/A"}</p>
      <p class="rating">${starsHTML}</p>
      <p class="feedback">"${review.FEEDBACK || "No feedback provided."}"</p>
    `;

    // Alternate: even index to left column, odd index to right column.
    if (index % 2 === 0) {
      leftColumn.appendChild(reviewCard);
    } else {
      rightColumn.appendChild(reviewCard);
    }
  });
}

// Convert Google Drive links into a working thumbnail format.
function convertGoogleDriveLink(originalLink) {
  if (!originalLink) return "";
  let fileIdMatch;

  // If the link is in the standard file/d/ format...
  if (originalLink.includes("drive.google.com/file/d/")) {
    fileIdMatch = originalLink.match(/\/d\/([a-zA-Z0-9_-]+)\//);
  }
  // If the link is already in the "uc?export=view" format...
  else if (originalLink.includes("drive.google.com/uc?export=view&id=")) {
    fileIdMatch = originalLink.match(/uc\?export=view&id=([a-zA-Z0-9_-]+)/);
  }
  
  if (fileIdMatch) {
    // Return the thumbnail format link (adjust size if needed)
    return `https://drive.google.com/thumbnail?id=${fileIdMatch[1]}&sz=w1000`;
  }
  
  // If no match, return the original link.
  return originalLink;
}
